import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';

export const styledMuiLink = (theme: Theme): BackstageOverrides['MuiLink'] => ({
  root: {
    color: theme.palette.link,
    fontWeight: 600,
    minWidth: 0,
    overflowWrap: 'anywhere',
    textDecorationColor: theme.palette.link,
    textUnderlineOffset: '0.2em',
    wordBreak: 'break-word',
    '&:hover': {
      color: theme.palette.linkHover,
      textDecorationColor: theme.palette.linkHover,
    },
  },
});
